import AppDispatcher from '../core/AppDispatcher.jsx';
import { EventEmitter } from 'events';
import ApplicationConstants from '../constants/ApplicationConstants';
import ApplicationHelper from '../utils/ApplicationHelper';
import SelectCustomerConstants from '../constants/SelectCustomerConstants.js';

const CHANGE_EVENT = 'change';
const ApplicationActionTypes = ApplicationConstants.ActionTypes;
const ApplicationLinkTypes = SelectCustomerConstants.ApplicationLinkTypes;

let _productId,
    _originationSource = ApplicationConstants.OriginationSources.FIRSTNET,
    _applicationLinkType,
    _applicationData,
    _clientSearchQuery,
    _canTransit,
    _searchResult,
    _isLoading = false;

function setApplicationData(applicationData) {
    _applicationData = applicationData;
    _productId = applicationData.productId;
    _originationSource = applicationData.originationSource;
}

function setApplicationLinkType(applicationLinkType) {
    _applicationLinkType = applicationLinkType
    _clientSearchQuery = getClientSearchQuery();
    _canTransit = !_clientSearchQuery;
    _isLoading = !!_clientSearchQuery;
    _searchResult = undefined;
}

function setSearchResult(result){
    _clientSearchQuery = null;
    _canTransit = true;
    _isLoading = false;
    _searchResult = result && result.clients && result.clients.length > 0 ?
        SelectCustomerConstants.SearchResult.FOUND :
        SelectCustomerConstants.SearchResult.NOT_FOUND;
}

function getClientSearchQuery() {
    // evaluate if there is a need to match the client using application data
    // requirement: if application's origination source is Iress(XPLAN) and application link type is EXISTING_LISTED_CLIENT
    // and date of birth provided, try finding the client by firstname, lastname and date of birth
    if (_applicationLinkType === ApplicationLinkTypes.EXISTING_LISTED_CLIENT &&
        _originationSource === ApplicationConstants.OriginationSources.IRESS) {
        var dob = ApplicationHelper.getClientFieldValue(_applicationData, 'dateOfBirth');
        if (dob) {
            return {
                firstName: ApplicationHelper.getClientFieldValue(_applicationData, 'givenName'),
                lastName: ApplicationHelper.getClientFieldValue(_applicationData, 'lastName'),
                dateOfBirth: dob
            };
        }
    }

    return null;
}

class ClientTypeStoreClass extends EventEmitter {
    constructor() {
        super();
    }

    addChangeListener(cb) {
        this.on(CHANGE_EVENT, cb);
    }

    removeChangeListener(cb) {
        this.removeListener(CHANGE_EVENT, cb);
    }

    emitChange() {
        return this.emit(CHANGE_EVENT);
    }

    getStore() {
        return {
            productId: _productId,
            applicationLinkType: _applicationLinkType,
            canTransit: _canTransit,
            clientSearchQuery: _clientSearchQuery,
            searchResult: _searchResult,
            isLoading: _isLoading
        };
    }
}

// Initialize the singleton to register with the
// dispatcher and export for React components
const ClientTypeStore = new ClientTypeStoreClass();

// Register each of the actions with the dispatcher
// by changing the store's data and emitting a change
ClientTypeStore.dispatchToken = AppDispatcher.register((action) => {

    switch (action.actionType) {
        case ApplicationActionTypes.APPLICATION_RETRIEVE_SUCCESS:
            setApplicationData(action.applicationData);
            break;

        case ApplicationActionTypes.SET_APPLICATION_LINK_TYPE:
            setApplicationLinkType(action.applicationLinkType)
            break;

        case SelectCustomerConstants.ActionTypes.CLIENT_SEARCH_COMPLETED:
            setSearchResult(action.result);
            break;
            
        default:
            return true;
    }

    ClientTypeStore.emitChange();
    return true;
});

export default ClientTypeStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/ClientTypeStore.js